import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TranslateTemplateBackLink(props) {
  return /*#__PURE__*/_jsx(UIBackButton, {
    children: /*#__PURE__*/_jsx(UILink, {
      onClick: props.onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.backLink"
      })
    })
  });
}
export default function TranslateTemplateSection(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "p-y-9 p-x-4",
    children: [/*#__PURE__*/_jsx(TranslateTemplateBackLink, {
      onClick: props.onBackClick
    }), /*#__PURE__*/_jsx(H4, {
      children: props.title
    }), props.children]
  });
}